import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import Constants from '../../../definitions/constants';
import { intl } from '../../../locales/localesConfig';

/* Actions */
import * as homeActions from '../../actions/home/index';
import * as dashboardActions from '../../actions/dashboard/index';

class Home extends Component {
  constructor(props) {
    super(props);
  }
 
  async componentDidMount() {
    this.props.handleCheckRouteAvailableTourReference(Constants.app.routes.home);
  }
  
  componentWillUnmount() {
  }
  
  componentDidUpdate(prevProps) {
  }

  render() {
    return (
      <section className="dashboard_content_inner_view home_container">
      </section>
    );
  }
}

const mapStateToProps = state => ({
  handleCheckRouteAvailableTourReference: state.reducer.dashboard.handleCheckRouteAvailableTourReference, 
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(homeActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch)
});

Home.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// ./source/client/containers/home/index.jsx